const resolveBackendUrl = (): string => {
  const configuredUrl = import.meta.env.VITE_BACKENDURL;
  const deployment = String(
    import.meta.env.VITE_DEPLOYMENT ?? "",
  ).toLowerCase();
  const isLocalDeployment = ["local", "dev", "development", "test"].includes(
    deployment,
  );

  if (typeof window === "undefined" || !configuredUrl) {
    return configuredUrl;
  }

  try {
    const backendUrl = new URL(configuredUrl);
    const currentHostname = window.location.hostname;
    const isLocalBackend =
      backendUrl.hostname === "localhost" ||
      backendUrl.hostname === "127.0.0.1";
    const isWorkspaceLocalhost = currentHostname.endsWith(".localhost");

    if (isLocalDeployment && isLocalBackend && isWorkspaceLocalhost) {
      backendUrl.hostname = currentHostname;

      return backendUrl.toString().replace(/\/$/, "");
    }

    return configuredUrl;
  } catch {
    return configuredUrl;
  }
};

export const env = {
  LANDING_PAGE: import.meta.env.VITE_LANDINGPAGE || "https://workplanx.com/",
  DEPLOYMENT: import.meta.env.VITE_DEPLOYMENT,
  MAIN_DOMAIN: import.meta.env.VITE_MAINDOMAIN,
  BACKEND_URL: resolveBackendUrl(),
  SOCKET_URL: import.meta.env.VITE_SOCKET_BASEURL,
  ADMIN_PORTAL: import.meta.env.VITE_ADMIN_PORTAL,
  CUSTOMER_PORTAL: import.meta.env.VITE_CUSTOMER_PORTAL,
  FILES_BASE_URL: import.meta.env.VITE_FILES_BASEURL,
  SENTRY_TUNNEL_URL: import.meta.env.VITE_SENTRY_TUNNEL_URL,
  MAINTENANCE_BYPASS_USER_EMAIL: import.meta.env
    .VITE_MAINTENANCE_BYPASS_USER_EMAIL,
  SIGNOZ_ACCESS_KEY: import.meta.env.VITE_SIGNOZ_ACCESS_KEY,
  SIGNOIZ_INGESTION_KEY: import.meta.env.VITE_SIGNOZ_INGESTION_KEY,
  /** WOR-4688: estimate sheet on the virtualized grid. On unless set to "false" (kill switch). */
  ESTIMATE_GRID_V2: import.meta.env.VITE_ESTIMATE_GRID_V2 !== "false",
  /** WOR-4688: task progress breakdown on the virtualized grid. On unless set to "false" (kill switch). */
  TASK_BREAKDOWN_V2: import.meta.env.VITE_TASK_BREAKDOWN_V2 !== "false",
  /** WOR-4688: claims breakdown on the virtualized grid. On unless set to "false" (kill switch). */
  CLAIMS_BREAKDOWN_V2: import.meta.env.VITE_CLAIMS_BREAKDOWN_V2 !== "false",
};
